import { Box } from '@spark-web/box';
import { Container } from '@spark-web/container';
import { Divider } from '@spark-web/divider';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextLink } from '@spark-web/text-link';
import {
  ABN_NUMBER,
  CREDIT_LICENSE_NUMBER,
  PAGE_FOOTER,
  PRIVACY_POLICY_URL,
  WEBSITE_TERMS_URL,
} from '@utils/constants';

type FooterProps = {
  termsLink?: string;
  showAcknowledgement?: boolean;
};

export const Footer = ({ termsLink, showAcknowledgement = false }: FooterProps) => {
  const {
    ACKNOWLEDGEMENT_OF_COUNTRY,
    BRIGHTE_ACKNOWLEDGEMENT_OF_COUNTRY,
    APPLICATION_SUBJECT_TO_APPROVAL,
    BRIGHTE_CAPITAL,
    PRIVACY_POLICY,
    SITE_TERMS,
  } = PAGE_FOOTER;

  const TERMS_LINK = termsLink ?? WEBSITE_TERMS_URL;

  return (
    <Box background="fieldAccent" paddingY="xxlarge">
      <Container size="medium">
        <Box paddingX={{ mobile: 'xlarge', desktop: 'large' }}>
          <Stack gap="xxlarge">
            {showAcknowledgement && (
              <>
                <Stack gap="xlarge">
                  <Text size="large">{ACKNOWLEDGEMENT_OF_COUNTRY}</Text>
                  <Text size="small">{BRIGHTE_ACKNOWLEDGEMENT_OF_COUNTRY}</Text>
                </Stack>

                <Divider color="standard" />
              </>
            )}

            <Stack gap="xlarge">
              <Text size="small">{CREDIT_LICENSE_NUMBER}</Text>
              <Text size="small">{APPLICATION_SUBJECT_TO_APPROVAL}</Text>

              <Text size="small">
                {BRIGHTE_CAPITAL} (ABN {ABN_NUMBER})
              </Text>

              <Inline gap="xsmall">
                <Text size="small">
                  <TextLink weight="regular" href={PRIVACY_POLICY_URL}>
                    {PRIVACY_POLICY}
                  </TextLink>
                </Text>
                <Text>—</Text>
                <Text size="small">
                  <TextLink weight="regular" href={TERMS_LINK}>
                    {SITE_TERMS}
                  </TextLink>
                </Text>
              </Inline>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};
